import { render, staticRenderFns } from "./AgendaDocumentsListView.vue?vue&type=template&id=2e1f9940&scoped=true&"
import script from "./AgendaDocumentsListView.vue?vue&type=script&lang=js&"
export * from "./AgendaDocumentsListView.vue?vue&type=script&lang=js&"
import style0 from "./AgendaDocumentsListView.vue?vue&type=style&index=0&id=2e1f9940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1f9940",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
